export const employeeHiringLink = {
  PHONE_PLACEHOLDER: '0000 00000',
  DOCUMENT_PLACEHOLDER: '0.000.000',
  'Account number': 'Número de cuenta',
  'Account type': 'Tipo de cuenta',
  'Account agency (without check digit)': 'Agencia (sin dígito verificador)',
  'Account owner fullname': 'Nombre completo del titular de la cuenta',
  Add: 'Agregar',
  'Add dependent': 'Agregar dependiente',
  'Add route': 'Agregar trayecto',
  Address: 'Dirección',
  'Alternative document': 'RUC',
  'Amount per day': 'Cant. por día',
  Asian: 'Amarilla',
  Attention: 'Atención',
  "Bachelor's degree completed": 'Universitario completo',
  "Bachelor's degree incomplete": 'Universitario incompleto',
  Back: 'Volver',
  Birthdate: 'Fecha de nacimiento',
  Black: 'Negra',
  'Check digit': 'Dígito verificador',
  Child: 'Hijo/Hija',
  'Cisgender man': 'Hombre cisgénero',
  'Cisgender woman': 'Mujer cisgénero',
  City: 'Ciudad',
  'City of birth': 'Ciudad de nacimiento',
  'Click or drag to attach a file':
    'Haga clic o arrastre para adjuntar un archivo',
  'Common-law marriage': 'Unión de hecho',
  'Dependent name': 'Nombre del dependiente',
  Dependents: 'Dependientes',
  District: 'Barrio',
  Divorced: 'Divorciado(a)',
  'Do you really want to remove this dependent?':
    '¿Realmente desea eliminar este dependiente?',
  'Do you really want to remove this route?':
    '¿Realmente desea eliminar este trayecto?',
  'Doctorate degree completed': 'Doctorado completo',
  'Doctorate degree incomplete': 'Doctorado incompleto',
  Document: 'CI',
  Documents: 'Documentos',
  Edit: 'Editar',
  'Education level': 'Nivel educativo',
  'Elementary school completed': 'Primaria completa',
  'Elementary school incomplete': 'Primaria incompleta',
  Email: 'Correo electrónico',
  'Emergency contact': 'Contacto de emergencia',
  'Employment offer': 'Oferta de empleo',
  'Father fullname': 'Nombre completo del padre',
  'Financial data': 'Datos bancarios',
  'Financial institution': 'Institución financiera',
  Finish: 'Finalizar',
  'Food voucher': 'Vale de alimentación',
  Fullname: 'Nombre completo',
  Grandparent: 'Abuelo/Abuela',
  'High school completed': 'Secundaria completa',
  'High school incomplete': 'Secundaria incompleta',
  Indigenous: 'Indígena',
  'Invalid file type': 'Tipo de archivo inválido',
  'Is this your first job?': '¿Es tu primer empleo?',
  'Is your work permit digital?': '¿Tu libreta de trabajo es digital?',
  'Issue date': 'Fecha de emisión',
  'Issuing authority': 'Autoridad emisora',
  "It's in my interest to receive transportation voucher":
    'Estoy interesado/a en recibir vale de transporte',
  'Lab coat size': 'Tamaño del guardapolvo',
  'Marital status': 'Estado civil',
  Married: 'Casado(a)',
  "Master's degree completed": 'Maestría completa',
  "Master's degree incomplete": 'Maestría incompleta',
  'Military service certificate number': 'Código de libreta militar',
  Mixed: 'Mestiza',
  'Mother fullname': 'Nombre completo de la madre',
  Next: 'Siguiente',
  'Next step': 'Siguiente paso',
  No: 'No',
  'No dependents added': 'No se agregaron dependientes',
  'No routes added': 'No se agregaron trayectos',
  'Non binary': 'No binario',
  'Not disclosed': 'No informado',
  'Operator/line': 'Operador/línea',
  'Operator/line code': 'Código del operador/línea',
  Other: 'Otro',
  'Owner identification document': 'C.I. del titular',
  Parent: 'Padre/Madre',
  Partner: 'Cónyuge',
  'Personal data': 'Datos personales',
  Phone: 'Teléfono',
  'Please, inform an integer value': 'Por favor, libere un valor entero',
  'Please, inform a valid date': 'Por favor, libere una fecha válida',
  'Please, inform a valid digit': 'Por favor, libere un dígito válido',
  'Please, inform a valid document': 'Por favor, libere una CI válida',
  'Please, inform a valid e-mail': 'Por favor, libere un email válido',
  'Please, inform a valid name': 'Por favor, libere un nombre válido',
  'Please, inform a valid value': 'Por favor, libere un valor válido',
  'Please, inform a valid whatsapp number':
    'Por favor, informe um número válido de whatsapp',
  'Postal code': 'Código postal',
  'Postgraduate studies completed': 'Posgrado completo',
  'Postgraduate studies incomplete': 'Posgrado incompleto',
  'Prefer not to answer': 'Prefiero no responder',
  Relationship: 'Relación',
  'Relationship level': 'Grado de parentesco',
  'Required documents': 'Documentos requeridos',
  Remove: 'Eliminar',
  Select: 'Seleccionar',
  Section: 'Sección',
  Series: 'Serie',
  'Shirt size': 'Tamaño de camiseta',
  Sibling: 'Hermano/Hermana',
  Single: 'Soltero(a)',
  State: 'Departamento',
  'State of alternate document issuance': 'Departamento del RUC',
  'The data of your proposal was successfully saved!':
    '¡Los datos de tu propuesta fueron guardados exitosamente!',
  'This employment offer refers to the position of <1>{{position}}</1>, with <3>{{employmentType}}</3> employment at the unit of <5>{{unit}}</5> and a salary of <7>{{salary}}</7>':
    'Esta oferta de empleo corresponde al cargo de <1>{{position}}</1>, con tipo de contratación <3>{{employmentType}}</3> en la unidad <5>{{unit}}</5> y un salario de <7>{{salary}}</7>.',
  'This field is required': 'Este campo es obligatorio',
  'Ticket type': 'Tipo de boleto',
  'Total value': 'Valor total',
  'Touch to attach a file': 'Toque para adjuntar un archivo',
  'Transgender man': 'Hombre transgénero',
  'Transgender woman': 'Mujer transgénero',
  'Transport/Company': 'Transporte/empresa',
  'Transport/Company type': 'Tipo de transporte/empresa',
  'Transportation routes': 'Trayecto de transporte',
  'Transportation voucher': 'Vale de transporte',
  'Transportation voucher and benefits': 'Vale de transporte y beneficios',
  Uniform: 'Uniforme',
  'Unit value': 'Valor unitario',
  'Upload the files required below Files without the <1>*</1> character are optional':
    'Suba los archivos requeridos abajo. Los archivos sin el carácter "<1>*</1>" son opcionales.',
  "We couldn't find your offer Please try again later":
    'No pudimos recuperar tu propuesta. Por favor, intentá de nuevo más tarde.',
  'Which gender do you identify with?': '¿Con qué género te identificás?',
  'Which race do you identify with?': '¿Con qué raza te identificás?',
  White: 'Blanca',
  Widowed: 'Viudo(a)',
  '<0>Via</0>laser hiring process': 'Proceso de contratación <0>Via</0>laser',
  'Voter registration card': 'Cédula electoral',
  Yes: 'Sí',
  'You can only attach one file!': '¡Solo podés adjuntar un archivo!',
  Zone: 'Zona',
};
